// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"38":"a40f771f","256":"0c2d3c0f","859":"77f34848","965":"5e8f753e"}[chunkId] + ".chunk.js";
};